import React, { useRef } from 'react';
import { animated } from 'react-spring';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { isShowGroupNav } from 'ducks/layout';
import SelectedMenu from './menus/SelectedMenu/SelectedMenu';
import ConflictMenu from './menus/ConflictMenu/ConflictMenu';
import InvalidPlacementsMenu from './menus/InvalidPlacementsMenu/InvalidPlacementsMenu';
import HelpLinesCollisionWarningMenu from './menus/HelpLinesCollisionWarningMenu/HelpLinesCollisionWarningMenu';
import RoomConfigurationMenu from 'components/RoomConfigurationMenu/RoomConfigurationMenu';
import UncoupledSlidingDoorsMenu from './menus/UncoupledSlidingDoorsMenu/UncoupledSlidingDoorsMenu';
import InvalidPlacedEntityMenu from './menus/InvalidPlacedEntityMenu/InvalidPlacedEntityMenu';
import { getRange } from 'utils/queryUtils';
import ErrorMessageToast from 'rangeConfig/shared/widgets/ErrorMessageToast';
import AutoFillSheet from 'rangeConfig/pax/features/AutofillPax/sheets/AutoFillSheet';
import EkrisMenu from '../../rangeConfig/eket/features/Ekris/EkrisMenu';
import { isGameEnabled } from 'rangeConfig/eket/features/Ekris/EkrisFeature';
import SidebarContent from './ProductSidebarContent';
import ProductGroupNav from './ProductGroupNav/ProductGroupNav';

const Sidebar = styled(animated.aside)`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  width: ${({ theme }) => theme.layout.sidebarWidth};
`;

const SidebarOutlet = styled.div`
  flex: 1;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const headerHeight = '6rem';

const Header = styled.div`
  position: relative;
  padding: 0.75rem 1rem;
  height: ${headerHeight};
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;
  display: flex;
  flex: 0 0 auto;
  background: white;
`;

const MenuWrapper = styled.div`
  display: flex;
  height: calc(100vh - ${headerHeight});
  position: relative;
  z-index: -1;
`;

const ProductSidebar = () => {
  const outletRef = useRef<HTMLDivElement | null>(null);
  const ekrisEnabled = useSelector(isGameEnabled);
  const isGroupNavVisible = useSelector(isShowGroupNav);

  const handleGroupClicked = () => {};

  const Navigation = () => {
    if (ekrisEnabled) {
      return <EkrisMenu />;
    }
    if (isGroupNavVisible) {
      return <ProductGroupNav onGroupClicked={handleGroupClicked} />;
    }
    return <SidebarContent />;
  };

  // if it set to anything, show selected group of products if not set then show menu
  return (
    <>
      <Sidebar data-testid="product-sidebar" id="product-sidebar">
        <Header />
        <MenuWrapper>
          <SidebarOutlet
            id="product-sidebar-toggle"
            aria-labelledby="product-sidebar-toggle"
            ref={outletRef}
          >
            <Navigation />
            <SelectedMenu />
            <RoomConfigurationMenu />
            <InvalidPlacementsMenu />
            {getRange() === 'smastad' && <InvalidPlacedEntityMenu />}
            <ConflictMenu />
            <HelpLinesCollisionWarningMenu />
            {getRange() === 'platsa' && <UncoupledSlidingDoorsMenu />}
            {getRange() === 'pax' && <AutoFillSheet />}
          </SidebarOutlet>
        </MenuWrapper>
      </Sidebar>
      <ErrorMessageToast />
    </>
  );
};

export default ProductSidebar;
